angular.module('b2bLoginApp.services')
    .factory('ProfileStrength', ['$http', function ($http) {
        return {
            getBreakdown: function () {
                return $http.get('profile-strength-breakdown');
            }
        };
    }]);
